import { makeStyles } from '@material-ui/core/styles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';


interface Props extends LayoutDirection {
  bordered: boolean;
}

export const useStyles = makeStyles(theme => ({
  root: {
    height: 59,
    width: '100%',
    borderRadius: 13,
    borderColor: theme.palette.grey['800'],
    borderWidth: ({ bordered }: Props) => (bordered ? 1 : 0),
    borderStyle: 'solid',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  titleContainer: {
    flex: 0.4,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  balanceContainer: {
    height: '100%',
    flex: 0.6,
    borderColor: theme.palette.grey['800'],
    borderLeftWidth: ({ bordered }: Props) => (bordered ? 1 : 0),
    borderRightWidth: ({ bordered }: Props) => (bordered ? 1 : 0),
    borderLeftStyle:  ({ direction }: LayoutDirection) => direction === 'rtl' ? 'none' : 'solid',
    borderRightStyle:  ({ direction }: LayoutDirection) => direction === 'rtl' ? 'solid' : 'none',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  balanceItems: {
    width: '100%',
    margin: ({ direction }: LayoutDirection) => direction === 'rtl' ? '0 20px 0 0' : '0 0 0 20px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  balance: {
    color: theme.palette.common.black,
    fontSize: 24,
    whiteSpace: 'nowrap',
  },
  arrowButton: {
    width: 42,
    height: 42,
    margin: ({ direction }: LayoutDirection) => direction === 'rtl' ? '0 0 0 8px' : '0 8px 0 0',
    padding: 0,
  },
  title: {
    color: theme.palette.grey[500],
    fontSize: theme.spacing(11),
  },
  menu: {
    marginTop: 60,
    width: 227,
    boxShadow: '0px 1px 14px #00000014',
    border: `1px solid ${theme.palette.grey[800]}`,
    borderRadius: 10,
    paddingLeft: 13,
    paddingRight: 13,
    paddingBottom: 10,
  },
  menuItem: {
    paddingBottom: 0,
  },
  menuItemCurrency: {
    paddingBottom: 4,
    borderBottomColor: theme.palette.grey['800'],
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
  },
}));
